/* eslint-disable vue/no-unused-components */
/* eslint-disable no-unused-vars */

//import ZenDataComponent from './components/ZenData.vue'
import {pushScopeId} from "vue";
import {isNotEmptyTextNode} from "eslint-plugin-vue/lib/utils/indent-utils";
import { FileSaver } from 'file-saver';

import {onFirstPause} from "@babel/core/lib/gensync-utils/async";
import {htmlEncode} from "js-htmlencode";

let hex16Table=[];
let hexTextTable=[];

let downloadBlob = function(data, fileName, mimeType) {
    var blob, url;
    blob = new Blob([data], {
        type: mimeType
    });
    url = window.URL.createObjectURL(blob);
    downloadURL(url, fileName);
    setTimeout(function() {
        return window.URL.revokeObjectURL(url);
    }, 1000);
};

let downloadURL = function(data, fileName) {
    var a;
    a = document.createElement('a');
    a.href = data;
    a.download = fileName;
    document.body.appendChild(a);
    a.style = 'display: none';
    a.click();
    a.remove();
};

/**
 *
 */
export class ZenData {
    /** @type {DataView}*/
    data=null;
    file=null;
    start=null;
    length=null;
    modified=false
    uid=null;
    children=null;
    viewHexStart=null;
    viewHexLength=null;
    displayChildIndex=false;
    componentName="ZenDataComponent";
    showHex=true;
    bigHex=false;
    displayInformation=null;
    parameterViewBuffered=null;
    groupName=null;
    block=null;
    showChildObjects=true;
    static dataLayout=null;

    constructor(file,start,length) {
        this.file = file;
        if (this.file!=null)
            this.data = file.data;
        this.start = start;
        this.length = length;
        this.viewHexStart = 0;
        this.viewHexLength = this.length = length;
        this.uid=Math.floor(Math.random()*1e10)+"-"+Math.floor(Math.random()*1e10);
        this.bigHex = this.length>500;
        this.showHex = !this.bigHex;
        this.createDisplayInformation();
    }

    static setDataLayout(layout) {
        ZenData.dataLayout = layout;
    }

    createDisplayInformation() {

    }

    readString(offset,length) {
        let arr = new Uint8Array(this.data.buffer, this.start+offset, length);
        return String.fromCharCode.apply(String, arr);
    }

    getUint32(offset) {
        return this.data.getUint32(this.start+offset, true);
    }

    getUint16(offset) {
        return this.data.getUint16(this.start+offset, true);
    }

    getUint8(offset) {
        return this.data.getUint8(this.start+offset );
    }

    getInt32(offset) {
        return this.data.getInt32(this.start+offset, true);
    }

    getInt16(offset) {
        return this.data.getInt16(this.start+offset, true);
    }

    getInt8(offset) {
        return this.data.getInt8(this.start+offset );
    }

    get containerClass() {
        return "";
    }

    get displayChildIndex() {
        return false;
    }

    hex() {
        if (this.viewHexStart==null)
            return null;
        if (this.hexBuffered)
            return this.hexBuffered;
        let startTime=window.performance.now();
        let len = this.viewHexLength;
        let lines=["<div><b>&nbsp;&nbsp;abs&nbsp;&nbsp;&nbsp;&nbsp;off&nbsp;&nbsp;00 01 02 03 &nbsp;04 05 06 07 &nbsp;08 09 0A 0B &nbsp;0C 0D 0E 0F | 0123456789ABCDEF</b></div>"];
        let col=0;
        let ptr = this.viewHexStart;
        let line="";
        let txtLine="";
        while(len>0) {
            if (col===0) {
                line = "<div><b>"+("000000" + (ptr+this.start).toString(16)).substr(-6) +" "+ ("000000" + (ptr).toString(16)).substr(-6)+"</b>";
            }
            let c=this.getUint8(ptr);
            line += hex16Table[c];
            txtLine+= hexTextTable[c];

            col++;
            if ( col % 4 ==0 )
                line+="&nbsp;";
            if ( col===16 ) {
                col=0;
                line+="| "+txtLine;
                line+="</div>";
                lines.push(line);
                txtLine=line = "";
            }
            len--;
            ptr++;
        }
        if (line!="")
            lines.push(line+"</div>");
        this.hexBuffered = lines.join("");

        // let endTime=window.performance.now();
        // let timed = Math.round((endTime-startTime)*1000);
        // console.log(`hex: ${this.viewHexLength} bytes in ${ timed }us = ${timed/this.viewHexLength} `);
        return this.hexBuffered;
    }

    setGroupName(name) {
        if (ZenData.dataLayout==null)
            return ;
        let group = ZenData.dataLayout.groups[name];
        if (group==undefined)
            return console.log(`cannot find group ${name}`);
        console.log(`Set Group ${name}`)
        console.log(group);

        if ( group.totalByteLength>this.length )
            return console.log(`Trying to set group to ${name} but length of group is ${group.totalByteLength}, larger than data ${this.length}`);
        this.children=[];
        for ( const groupItem of group.blocks ) {
            console.log(groupItem);
            if ( groupItem.count==1 ) {
                const newItem = new ZenData(this.file, this.start+groupItem.byteOffset[0], groupItem.blockByteLength);
                newItem.setBlockName(groupItem.blockName);
                this.children.push(newItem);
            } else {
                const newItem = new ZenFixedArray(this.file, this.start+groupItem.byteOffset[0], groupItem.totalByteLength,ZenData, groupItem.count,groupItem.blockByteLength);
                newItem.setBlockName(groupItem.blockName);
                newItem.showChildObjects=false;
                for(let i=0;i<groupItem.count;i++)
                    newItem.children[i].setBlockName(groupItem.blockName);
                this.children.push(newItem);
            }

        }

        this.groupName = name;
    }

    setBlockName(name) {
        if (ZenData.dataLayout==null)
            return ;

        let block = ZenData.dataLayout.blocks[name];
        if (block==undefined)
            return console.log(`cannot find block ${name}`);
        console.log(`set block ${name}`);
        console.log(block);
        this.block = block;
        this.showHex=false;
    }

    hasParameterView() {
        return this.block!=null;
    }

    getParameterValues() {
        if ( this.block == null )
            return null;

        let rv = new Array();
        for ( let param of this.block.parameters ) {
            let val=null;

            // fix NAME
            let nameMatch = param.id.match(/NAME_(\d+)/);
            if ( nameMatch!==null ) {
                if (nameMatch[1]!='1')
                    continue;
                rv.push(this.readString(param.byteOffset,16).trimRight());
                continue;
            }

            switch ( param.lengthBytes ) {
                case 1:
                    val = this.getInt8(param.byteOffset);
                    break;
                case 2:
                    val = this.getInt16(param.byteOffset);
                    break;
                case 4:
                    val = this.getInt32(param.byteOffset);
                    break;
            }

            if ( val!=null) {
                if ( param.values !== null) {
                    val = param.values[val]===undefined ? 'invalid value' : param.values[val];
                } else if ( param.displayRange!==undefined ) {
                    val = ( val - param.dataRange[ 0 ] ) * ( param.displayRange[ 1 ] - param.displayRange[ 0 ] ) / ( param.dataRange[ 1 ] - param.dataRange[ 0 ] ) + param.displayRange[ 0 ];
                    let multiplicator = Math.pow(10, 1);
                    let n = parseFloat((val * multiplicator).toFixed(11));
                    val = Math.round(n) / multiplicator;

                    console.log(val);
                }
                rv.push(String(val));
            } else
                rv.push("xxx");
        }
        return rv;
    }

    // override for arrays
    getAllParameterValues() {
        return[ this.getParameterValues() ];
    }

    parameterView() {
        if ( this.block == null )
            return null;

        if ( this.parameterViewBuffered != null )
            return this.parameterViewBuffered;

        let paramData = this.getAllParameterValues();
        let paramDataCount = paramData.length;

        let out=new Array();
        out.push("<table class='table table-sm table-striped table-bordered'>");
        let row=0;
        for ( let param of this.block.parameters ) {
            // fix NAME
            let nameMatch = param.id.match(/NAME_(\d+)/);
            if ( nameMatch!==null ) {
                if (nameMatch[1]!=='1')
                    continue;
            }

            let desc = param.displayMeasurement!=null ? `${param.description} (${param.displayMeasurement})` : param.description;

            out.push('<tr>');
            out.push(`<td><b>${htmlEncode(desc)}</b></td>`);
            for (let value of paramData ) {
                out.push(`<td>${value[row]}</td>`);
            }
            out.push('</tr>');
            row++;
        }
        out.push("</table");
        this.parameterViewBuffered = out.join('');

        return this.parameterViewBuffered;
    }

    saveFile() {
        let dv = new Uint8Array(this.data.buffer, this.start, this.length);
        let blob = new Blob(dv, {type: "octet-stream"});
        let fname = `${this.file.name}_${this.start}_${this.length}`;
        if (this.name!==undefined)
            fname = this.name;
        if ( this.getDownloadFilename !== undefined )
            fname = this.getDownloadFilename();

        fname += ".bin";
        downloadBlob(dv, fname, 'application/octet-stream');
    }

    toggleShowHex() {
        this.showHex = ! this.showHex;
    }

    toggleShowChildObjects() {
        this.showChildObjects = ! this.showChildObjects;
    }
}



        /**
         *
         */
// eslint-disable-next-line
class ZenChunk extends ZenData {
    type=null;

    constructor(type,data,start, length) {
        super(data, start, length);
        this.type = type;
        this.displayChildIndex=true;
        this.componentName="ZenChunkComponent";
    }

    static createZenChunk(type,data,start,length) {
        if (ZenChunkTypes[type]!==undefined) {
            return new ZenChunkTypes[type](type, data, start, length)
        }
        return new ZenChunk(type, data, start, length);
    }


    read() {}
}

/**
 *
 */
class ZenChunkWithArray extends ZenChunk {
    constructor(type,data,start,length, childType, parentType) {
        super(type, data, start, length);
        if ( childType===undefined )
            childType = ZenData;
        this.viewHexStart=null;
        this.read( childType,parentType );
    }

    read(childType,parentType) {
        this.children = new Array(1);
        if ( parentType!==undefined )
            this.children[0] = new parentType(this.file, this.start,this.length,childType);
        else
            this.children[0] = new ZenArray(this.file, this.start,this.length,childType);
    }

}

/**
 *
 */
class ZenPATaZCOR extends ZenChunkWithArray {
    constructor(type,file,start,length) {
        super(type, file, start, length,ZenTonePATObject,ZenToneArray);
        this.componentName="ZenPATaZCORComponent";
    }
}

class ZenMDLaZCOR extends ZenChunkWithArray {
    constructor(type,file,start,length) {
        super(type, file, start, length,ZenToneMDLObject,ZenToneArray);
        this.componentName="ZenMDLaZCORComponent";
    }
}

/**
 *
 */
const ZenToneType = Object.freeze({
    unknown:"unknown",
    pat:"ZenCore",
    mdl:"Model",
});

/**
 *
 */
class ZenDataWithName extends ZenData {
    constructor(file,start,end) {
        super(file,start,end);
        this.name = this.readString(0,16).trimRight();
    }
}

/**
 *
 */
class ZenToneObject extends ZenDataWithName {
    type=ZenToneType.unknown;
    checksum=null;
    location="";

    constructor(file,start,end) {
        super(file,start,end);
        this.showHex=false;
        this.displayChildIndex=true;
    }

    createDisplayInformation() {
        let di={};
        di['Name']=this.name;
        di['Type']=this.type;
        di['Location']=this.location;
        di['Checksum']=this.checksum;
        this.displayInformation = di;
    }

    getDownloadFilename() {
        return this.name +"_"+( this.type==ZenToneType.mdl ? "MDL" : "PAT" );
    }
}

/**
 *
 */
class ZenTonePATObject extends ZenToneObject {
    constructor(file,start,end) {
        super(file,start,end);
        this.type=ZenToneType.pat;
        this.setGroupName("PCMEX");
    }
}

class ZenToneMDLObject extends ZenToneObject {
    constructor(file,start,end) {
        super(file,start,end);
        this.type=ZenToneType.mdl;
    }
}


/**
 *
 */
class ZenPATaData extends ZenData {
    constructor(file,start,length) {
        super(file, start, length);
    }
}

/**
 *
 */
class ZenArray extends ZenData {
    constructor(file,start,length, childType) {
        super(file,start,16);
        if ( childType===undefined )
            childType = ZenData;
        this.displayChildIndex=true;
        this.componentName = "ZenArrayComponent";
        this.read(childType);
        this.showHex=true;
    }

    childCreated(child,index) {

    }

    get containerClass() {return "ZenArrayContainer";}

    get childLength() { return this.getUint32(4) }

    get dataStartOffset() { return this.getUint32(8) }

    get extraDataLength() { return this.dataStartOffset - this.length }

    get unknownData() { return this.getUint32(12) }

    read(childType) {
        let count = this.getUint32(0);
        this.children = new Array(count);
        let st = this.start+this.dataStartOffset;
        let len = this.childLength;
        for ( let i=0;i<count;i++ ) {
            this.children[i] = new childType(this.file, st + i * len, len)
            this.childCreated(this.children[i],i);
        }
        this.viewHexLength=this.dataStartOffset;
    }
}

/**
 *
 */
class ZenToneArray extends ZenArray {
    constructor(file,start,length, childType) {
        super(file,start,length, childType);
        this.showHex=false;
    }

    childCreated(child,index) {
        let checksum=null;
        if ( this.extraDataLength>=(index+1)*4 )
            checksum = this.getUint32(16+index*4);

        child.checksum=checksum;
        child.createDisplayInformation();
        this.file.tones.push(child);
    }
}

/**
 *
 */
class ZenFixedArray extends ZenData {
    constructor(file, start, length, childType, childCount, childLength) {
        super(file, start, length);
        this.displayChildIndex = true;
        this.dataStartOffset = 0;
        this.componentName = "ZenFixedArrayComponent";
        this.showHex = false;
        this.read(childType, childCount, childLength);
    }

    read(childType, count, childLength) {
        this.children = new Array(count);
        let st = this.start + this.dataStartOffset;
        for ( let i = 0; i < count; i++ )
            this.children[i] = new childType(this.file, st + i * childLength, childLength)
    }

    getAllParameterValues() {
        if ( this.block == null )
            return null;

        let rv = [];
        for ( const child of this.children ) {
            rv.push(child.getParameterValues());
        }
        return rv;
    }
}

/**
 *
 */
class ZenDataBlockWithName extends ZenData {
    constructor(file, start, length,showHex) {
        super(file, start, length);
        if (showHex!==undefined)
            this.showHex=showHex;
        this.displayChildIndex = true;
        this.componentName = "ZenDataBlockWithNameComponent";
        this.showHex = false;
    }
}

/**
 *
 */
class ZenPRJData extends ZenDataWithName {
    constructor(file, start, length) {
        super(file, start, length);

    }
}

/**
 *
 */
class ZenPRJChunk extends ZenChunkWithArray {
    constructor(file, data, start, length) {
        super(file,data, start, length,ZenPRJData);
    }
}

/**
 *
 *
 */
const ZenFileType = Object.freeze({
    unknown:0,
    svz:1,
    mpj:2,
    svd:3
});

class Tone {
    name=null;
    type=ZenToneType.unknown;
    checksum=null;
    uid=Math.floor(Math.random()*1e10)+"-"+Math.floor(Math.random()*1e10);
}

/**
 *
 */
export class ZenFile extends ZenData {
    name="";
    type=ZenFileType.unknown;
    fileLength=0;
    tones=[];

    constructor(name,data) {
        super(null,0, data.byteLength);
        this.data = data;
        this.file=this;
        this.name=name;
        this.fileLength=data.byteLength
        this.componentName = "ZenFileComponent";
    }

    read() {
        if ( this.data.getUint32(0)==0x53565A61 ) {
            this.type=ZenFileType.svz;
            this.readChunks(this.data.getUint8(4));
        } else if ( this.data.getUint32(2)==0x50524A35 ) {
            this.type=ZenFileType.mpj;
            let numChunks = (this.getUint16(0)+2-16) /16;
            this.readChunks(numChunks);
        }  else if ( this.data.getUint32(2)==0x53564435 ) {
            this.type = ZenFileType.svd;
            let numChunks = (this.getUint16(0) + 2 - 16) / 16;
            this.readChunks(numChunks);
        }
        else
            this.viewHexLength = Math.min(this.length, 1024);
    }

    readChunks( numChunks ) {
        this.children = new Array( numChunks );
        for ( let i=0; i<numChunks; i++ ) {
            let offset = 16*(i+1);
            let type = this.readString(offset,8);
            let length = this.getUint32(offset+12);
            let start = this.getUint32(offset+8);
            this.children[i] = ZenChunk.createZenChunk(type, this.file,start, length);
        }
        this.viewHexStart=0;
        this.viewHexLength=16+numChunks*16;
        this.showHex = true;

    }

    get typeDescription() {
        switch ( this.type ) {
            case ZenFileType.svz:
                return "SVZ";
            case ZenFileType.mpj:
                return "MPJ"
        }
        return "Unknown";
    }
}

let ZenChunkTypes = {
    "PATaZCOR":ZenPATaZCOR,
    "MDLaZCOR":ZenMDLaZCOR,
    "DIFaZCOR":ZenChunkWithArray,
    "PRJaMC77":ZenPRJChunk,
    "PRFaKY19":ZenChunkWithArray,
    "PATaKY19":ZenPATaZCOR,
    "SNAaKY19T":ZenChunkWithArray,
    "SYSaKY19":ZenChunkWithArray,
    "DIFaKY19":ZenChunkWithArray
}

// build hex/text table
for ( let i=0; i<256;i++) {
    hex16Table.push(" " + ("00" + (i).toString(16)).substr(-2).toUpperCase());
    if (i<32)
        hexTextTable.push(".");
    else
        hexTextTable.push(String.fromCharCode(i));
}
